<template>
  <div class="home-join-WR" ref="homeJoinWR">
    <img loading="lazy" class="home-joinWR-bg" src="@/assets/img/home/joinWRImg1.png" alt="">
    <Transition enter-active-class="animate__slideInUp" leave-active-class="animate__slideOutDown">
      <img loading="lazy" class="joinWR-text animate__animated " v-if="offsetTop < 650"
        src="@/assets/img/home/joinWRText1.png" alt="">
    </Transition>
    <div class="recruitment-information">
      <div class="school-recruitment">
        <img loading="lazy" class="joinWR-type-bg" src="@/assets/img/home/joinWRImg2.png" alt="">
        <div class="type animate__animated animate__slideInUp">{{ '校园招聘' }}</div>
        <div class="year">{{ year + '校园招聘' }}</div>
        <el-divider></el-divider>
        <div class="condition">{{ year - 1 + '年9月-' + year + '年8月期间毕业' }}</div>
        <el-button type="primary" plain round size="medium"
          @click="$router.push({ name: 'joinWR', params: { position: true } })">查看详情</el-button>
      </div>
      <div class="social-recruitment">
        <img loading="lazy" class="joinWR-type-bg" src="@/assets/img/home/joinWRImg3.png" alt="">
        <div class="type"> {{ '社会招聘' }}</div>
        <div class="position-container">
          <div class="position" v-for="item in postList" :key="item.id">
            <img loading="lazy" class="position-icon" src="@/assets/img/home/joinWRImg4.png" alt="">
            <div>{{ item.position }}</div>
          </div>
        </div>
        <el-button type="primary" plain round size="medium"
          @click="$router.push({ name: 'joinWR', params: { position: true } })">查看详情</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: '',
  components: {

  },
  props: ['offsetTop'],
  data() {
    return {
      moment,
      year: moment().year(),
      postList: [],
    }
  },
  created() {
    this.getJoinWRData()
  },
  mounted() {

  },
  methods: {
    getJoinWRData() {
      this.$apis.join_wr_list().then(res => {
        this.postList = res.data.filter(item => item.homeShowFlag == '是').slice(0, 5)
      })
    },
  },
}
</script>

<style lang='scss' scoped>
.home-join-WR {
  position: relative;
  height: 62.5rem;
  color: #FFFFFF;
  font-family: FZLanTingHei-R-GBK;
  display: flex;
  justify-content: center;

  .home-joinWR-bg {
    width: 120rem;
    height: 62.5rem;
  }

  .joinWR-text {
    width: 24.3125rem;
    height: 5rem;
    position: absolute;
    top: 6rem;
  }

  .recruitment-information {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -40%);
    display: flex;
    column-gap: 4.5rem;

    .school-recruitment,
    .social-recruitment {
      position: relative;
      letter-spacing: 3px;


      .joinWR-type-bg {
        width: 37.875rem;
        height: 25.4375rem;
      }

      .type {
        position: absolute;
        font-weight: 600;
        font-size: 1.5rem;
        left: 1.5rem;
        top: 1.25rem;
      }

      .el-button {
        position: absolute;
        bottom: 1.875rem;
        right: 2.5rem;
        position: absolute;
        background: transparent;
        color: #ffffff;
        border-color: #ffffff;
      }

      .el-button:hover {
        color: #0096FF;
        border-color: #0096FF;
      }
    }

    .school-recruitment {

      .year {
        position: absolute;
        font-size: 1.5rem;
        left: 3.75rem;
        top: 10rem;
      }

      .el-divider--horizontal {
        position: absolute;
        margin: 0;
        background: #E0E0E0;
        left: 3.75rem;
        top: 12.1875rem;
        width: 11.25rem;
      }

      .condition {
        position: absolute;
        font-size: 1.25rem;
        left: 3.75rem;
        top: 12.5rem;
      }
    }

    .social-recruitment {
      .position-container {
        display: flex;
        flex-direction: column;
        position: absolute;
        top: 5rem;
      }

      .position {
        font-weight: 400;
        font-size: 1.25rem;
        margin-top: 1.25rem;
        margin-left: 5rem;
        height: 1.625rem;
        line-height: 1.625rem;
        display: flex;
        align-items: center;
        justify-content: flex-start;

        .position-icon {
          width: 1.125rem;
          height: 1.125rem;
        }

        div {
          display: inline-block;
          margin-left: 1.125rem;
        }
      }
    }

  }
}
</style>